<mat-list role="list" style="margin-top: 2rem;">
  @for (mod of enabledMods; track mod) {
    @if (mod.enabled && !mod.subModules) {
      <mat-list-item class="menuitems">
        <a class="link-hover" routerLink="/{{ mod.route }}" href="#">
          <span class="material-icons" style="color: #0093a1">keyboard_arrow_right</span><span
        style="padding-right: 10px;">&nbsp;{{mod.name}}</span><mat-icon
      class={{mod.iconClass}}>{{mod.icon}}</mat-icon>
    </a>
  </mat-list-item>
}
@if (mod.enabled && mod.subModules) {
  <mat-list-item [matMenuTriggerFor]="menu" class="menuitems">
    <a class="link-hover">
      <span class="material-icons" style="color: #0093a1">unfold_more</span><span
    style="padding-right: 10px;">&nbsp;{{mod.name}}</span><mat-icon
  class={{mod.iconClass}}>{{mod.icon}}</mat-icon>
</a>
<mat-menu #menu="matMenu">
  @for (subMod of mod.subModules; track subMod) {
    <a class="submod-link" routerLink="/{{ subMod.route }}" href="#">
      {{ subMod.name }}<mat-icon style="padding-left: 10px;">{{ subMod.icon }}</mat-icon>
    </a>
  }
</mat-menu>
</mat-list-item>
}
}
</mat-list>